import { createActions } from "redux-actions";

export const constants = {
  UPDATE_PROVIDER_FORM_FIELD: "UPDATE_PROVIDER_FORM_FIELD",
  UPDATE_PROVIDER_LIST_FILTERS: "UPDATE_PROVIDER_LIST_FILTERS",
  RESET_PROVIDER_FORM_FIELDS: "RESET_PROVIDER_FORM_FIELDS",
  RESET_PROVIDER_LIST_FILTERS: "RESET_PROVIDER_LIST_FILTERS",
  SUBMIT_PROVIDER_FORM: "SUBMIT_PROVIDER_FORM",
  FETCH_PROVIDER_LIST: "FETCH_PROVIDER_LIST",
  DELETE_PROVIDER: "DELETE_PROVIDER",
  UPDATE_PROVIDER: "UPDATE_PROVIDER",
  FETCH_PROVIDER: "FETCH_PROVIDER",
};

export const actions = createActions({
  SUBMIT_PROVIDER_FORM: {
    REQUEST: ({ form }) => ({ form }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  FETCH_PROVIDER_LIST: {
    REQUEST: ({ providerType }) => ({ providerType }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  DELETE_PROVIDER: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  UPDATE_PROVIDER: {
    REQUEST: ({ provider }) => ({ provider }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  FETCH_PROVIDER: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
  RESET_PROVIDER_FORM_FIELDS: (showMessage = true) => ({ showMessage }),
});
